<div class="row">
  <div class="col-md-1 mt-2">
    <input
      type="checkbox"
      name="gender"
      value="all"
      class="font15"
      id="residentialId"
      (click)="resiClick($event)"
    />
    All
  </div>
  <div class="col-md-3 pr-0 mt-2">
    <select class="form-control">
      <option *ngFor="let option of options" [value]="option">{{ option }}</option>
    </select>
  </div>
</div>
<div class="col-12 p-0 d-flex mb-3 mt-3">
  <div class="col-3 px-0 mr-2">
    <span class="mt-2 mr-2">From:</span>
    <my-date-picker
      name="FromDate"
      id="date1"
      #FromDate="ngModel"
      [options]="myDatePickerOptions1"
      [(ngModel)]="fromdate"
      class="admindate"
      placeholder="MM/DD/YYYY"
      required
      [disabled]="selectedDates"
    ></my-date-picker>
  </div>
  <div class="col-3 px-0 mr-2">
    <span class="mt-2 mr-2">Affiliate name:</span>
    <input
      name="FromDate"
      id="AffiliateName"
      class="form-control placeholderstyle"
      placeholder="Affiliate name"
      [(ngModel)]="AffiliateName"
     
    >
  </div>
  <div class="col-3 px-0 mr-2">
    <span class="mt-2 mr-2">Affiliate Contact Person:</span>
    <input
      name="AffiliateContactPerson"
      id="AffiliateContactPerson"
      class="form-control placeholderstyle"
      placeholder="Affiliate contact person"
      [(ngModel)]="AffiliateContactPerson"
     
    >
  </div>
</div>
<div class="col-12 p-0 d-flex">
  <div class="col-sm-3 px-0 mr-2">
    <span class="mt-2 mr-2">To:</span>
    <my-date-picker
      name="ToDate"
      id="date2"
      #ToDate="ngModel"
      [options]="myDatePickerOptions1"
      [(ngModel)]="todate"
      placeholder="MM/DD/YYYY"
      required
      [disabled]="selectedDates"
      
    ></my-date-picker>
  </div>
  <div class="col-sm-3 px-0 mr-2">
    <span class="mt-2 mr-2">Promo code:</span>
    <input
    name="PromoCode"
    id="PromoCode"
    class="form-control placeholderstyle"
    placeholder="Promo code"
    [(ngModel)]="PromoCode"
    
   
  >
  </div>
  <div class="col-3 px-0 mr-2">
    <span class="mt-2 mr-2">Affiliate Phone:</span>
    <input
      name="AffiliatePhone"
      id="AffiliatePhone"
      class="form-control placeholderstyle"
      placeholder="Affiliate phone"
      [(ngModel)]="AffiliatePhone"
     
    >
  </div>

  <!-- <div class="col-sm-4 mt-4"></div> -->
</div>

<div class="col-12 p-0 d-flex">
  <div class="col-sm-3 px-0 mr-2">
    <span class="mt-2 mr-2">TDSP:</span>
    <!-- <input style="margin-left: 2px;"
    name="TDSP"
    id="TDSP"
    class="form-control placeholderstyle"
    placeholder="TDSP"
    [(ngModel)]="TDSP"
    
   
  > -->
  <select style="margin-left: 2px;" [(ngModel)]="TDSP" class="form-control">
    <option  *ngFor="let option of TDSPs" [value]="option">{{ option }}</option>
  </select>
  </div>
  <div class="col-sm-3 px-0 mr-2">
    <span class="mt-2 mr-2">Brand:</span>
    <!-- <input
    name="Brand"
    id="Brand"
    class="form-control placeholderstyle"
    placeholder="Brand"
    [(ngModel)]="Brand"
    
   
  > -->
  <select [(ngModel)]="Brand" class="form-control">
    <option  *ngFor="let option of Brands" [value]="option">{{ option }}</option>
  </select>
  </div>


  <div class="col-sm-2 pt-0 px-0 mt-4">
    <a
      class="mt-0 btn sectbtn brdrRadius"
      href="javascript:void(0)"
      (click)="GetDataTable()"
      style="
        border-color: #ed1976 !important;
        background-color: #ed1976;
       
      "
    >
      SEARCH
    </a>
    <a style="margin-left: 15px;"
      class="btn sectbtn brdrRadius"
      href="javascript:void(0)"
      (click)="exportAsXLSX()"
      >EXPORT</a
    >
  </div>

  <!-- <div class="col-sm-4 mt-4"></div> -->
</div>
<div class="card mt-2">
  <div class="table-responsive" id="enrollmentTable">
    <table mat-table [dataSource]="utilityData" matSort #empTbSort="matSort">
      <!-- Position Column -->
      <ng-container matColumnDef="currentStatus">
        <th mat-header-cell *matHeaderCellDef>Current Status</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ setCurrentStatus(element.status, element) }} -->
          {{ element.CurrentStatus }}
          
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          {{ element.status }}
        </td>
      </ng-container>
      <ng-container matColumnDef="customerId">
        <th mat-header-cell *matHeaderCellDef>Customer Id</th>
        <td mat-cell *matCellDef="let element">
          {{ element.customerId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="energy_provider">
        <th [ngClass]="''" mat-header-cell *matHeaderCellDef mat-sort-header>Brand</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.selectedProduct.energy_provider }} -->
          {{ element.energy_provider }}
        </td>
      </ng-container>
      <ng-container matColumnDef="utility_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>TSDP</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.selectedProduct.utility_name }} -->
          {{ element.utility_name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="ProfileCreatedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Profile Creation Date
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.ProfileCreatedDate | date: 'MM/dd/yyyy h:mm a'}}
        </td>
      </ng-container>
     
      <ng-container matColumnDef="switchDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Service Start Date</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.serviceTypeDetails.switchDate }} -->
          {{ element.switchDate }}
        </td>
      </ng-container>
      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Signup Date
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdDate | date: 'MM/dd/yyyy h:mm a'}}
        </td>
      </ng-container>
      <ng-container matColumnDef="legalFirstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>FirstName</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.contactInfo.legalFirstName }} -->
          {{ element.legalFirstName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="legalLastName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.contactInfo.legalLastName }} -->
          {{ element.legalLastName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="emailId">
        <th mat-header-cell *matHeaderCellDef>Email Address</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.contactInfo.emailId }} -->
          {{ element.emailId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="homephoneNo">
        <th mat-header-cell *matHeaderCellDef>Home Phone</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.contactInfo.phoneNo }} -->
          {{ element.phoneNo }}
        </td>
      </ng-container>
      <ng-container matColumnDef="mobilePhone">
        <th mat-header-cell *matHeaderCellDef>Mobile Phone</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.contactInfo.phoneNo }} -->
          {{ element.phoneNo }}
        </td>
      </ng-container>
      <ng-container matColumnDef="workPhone">
        <th mat-header-cell *matHeaderCellDef>Work Phone</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.contactInfo.phoneNo }} -->
          {{ element.phoneNo }}
        </td>
      </ng-container>
      <ng-container matColumnDef="authorizedRep">
        <th mat-header-cell *matHeaderCellDef>Authorized Representative</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.contactInfo.authorizedRep }} -->
          {{ element.authorizedRep }}
        </td>
      </ng-container>
      <ng-container matColumnDef="esiid">
        <th mat-header-cell *matHeaderCellDef>ESIID</th>
        <td mat-cell *matCellDef="let element">{{ element.esiid }}</td>
      </ng-container>
      <ng-container matColumnDef="userAddress1">
        <th mat-header-cell *matHeaderCellDef>Service Address 1</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.billingAddress.userAddress.street_address }} -->
          {{ element.servicestreet_address }}
        </td>
      </ng-container>
      <ng-container matColumnDef="userAddress2">
        <th mat-header-cell *matHeaderCellDef>Service Address 2</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.billingAddress.userAddress.city }}+-->
          <!-- {{ element.billingAddress.apartment }} -->
          {{ element.serviceapartment }}
        </td>
      </ng-container>
      <ng-container matColumnDef="userCity">
        <th mat-header-cell *matHeaderCellDef>Service City</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.billingAddress.userAddress.city }} -->
          {{ element.servicecity }}
        </td>
      </ng-container>
      <ng-container matColumnDef="userState">
        <th mat-header-cell *matHeaderCellDef>Service State</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.billingAddress.userAddress.state }}  -->
          {{ element.servicestate }}
        </td>
      </ng-container>
      <ng-container matColumnDef="userZIPCode">
        <th mat-header-cell *matHeaderCellDef>Service Zip Code</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.billingAddress.userAddress.zipcode }} -->
          {{ element.serviceZipcode}}
        </td>
      </ng-container>
      <ng-container matColumnDef="billingAddress1">
        <th mat-header-cell *matHeaderCellDef>Billing Address1</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{
            element.billingAddress.billingAddress.billingAddress.street_address
          }} -->
          {{
            element.billingstreet_address
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="billingAddress2">
        <th mat-header-cell *matHeaderCellDef>Billing Address2</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.billingAddress.apartment }} -->
          {{ element.billingapartment }}
        </td>
      </ng-container>
      <ng-container matColumnDef="billingCity">
        <th mat-header-cell *matHeaderCellDef>Billing City</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.billingAddress.userAddress.city }} -->
          {{ element.billingcity }}
        </td>
      </ng-container>
      <ng-container matColumnDef="billingState">
        <th mat-header-cell *matHeaderCellDef>Billing State</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.billingAddress.userAddress.state }} -->
          {{ element.billingstate }}
          
        </td>
      </ng-container>
      <ng-container matColumnDef="billingZIPCode">
        <th mat-header-cell *matHeaderCellDef>Billing Zip Code</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.billingAddress.userAddress.zipcode }} -->
          {{ element.billingzipcode }}
        </td>
      </ng-container>
      <ng-container matColumnDef="serviceType">
        <th mat-header-cell *matHeaderCellDef>Service Type</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.serviceTypeDetails.serviceType }} -->
          {{ element.serviceType }}
        </td>
      </ng-container>
      <ng-container matColumnDef="RequestedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Requested StartDate</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ setRequestedDate(element.serviceTypeDetails.switchDate) }} -->
          {{ element.RequestedDate | date: 'MM/dd/yyyy'}}
        </td>
      </ng-container>
      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef>End Date</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ setEndDate(element.serviceTypeDetails.switchDate, element) }} -->
          {{ element.enddate }}
        </td>
      </ng-container>
      <ng-container matColumnDef="energyRate">
        <th mat-header-cell *matHeaderCellDef>Energy Rate</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.selectedProduct.energy_charge }} -->
          {{ element.energy_charge }}
        </td>
      </ng-container>
      <ng-container matColumnDef="avgUsage">
        <th mat-header-cell *matHeaderCellDef>Avg Usage</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ setAverage(element.selectedProduct.new_tier.ave_monthly_usage) }} -->
          {{ element.ave_monthly_usage }}
        </td>
      </ng-container>
      <ng-container matColumnDef="term">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Term</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.selectedProduct.terms }} -->
          {{ element.terms }}
        </td>
      </ng-container>
      <ng-container matColumnDef="planName">
        <th mat-header-cell *matHeaderCellDef>Plan Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element.ratePlanName }}
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="ConfirmationNumber">
        <th mat-header-cell *matHeaderCellDef>ConfirmationNumber</th>
        <td mat-cell *matCellDef="let element">
          {{ element.ConfirmationNumber }}
        </td>
      </ng-container>

      <!-- Weight Column -->

      <ng-container matColumnDef="renewableContent">
        <th mat-header-cell *matHeaderCellDef>Renewable Content</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.selectedProduct.Renewable }} -->
          <!-- {{ setContent(element.selectedProduct.Renewable) }} -->
          {{ element.Renewable }}
        </td>
      </ng-container>
      <ng-container matColumnDef="enrollmentSource">
        <th mat-header-cell *matHeaderCellDef>Enrollment Source</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.promoDetails.hearusOption }} -->
          {{ element.hearusOption }} 
        </td>
      </ng-container>
      <ng-container matColumnDef="UsedPromocode">
        <th mat-header-cell *matHeaderCellDef>Promo code</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.promoDetails.promoeCode }} -->
           {{ element.promoeCode }}
        </td>
      </ng-container>
      <ng-container matColumnDef="AffiliateName">
        <th mat-header-cell  *matHeaderCellDef mat-sort-header>Affiliate Name</th>
        <td mat-cell  *matCellDef="let element">
          {{ element.AffiliateName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="AffiliatePromoCode">
        <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header>Affiliate Promo code</th>
        <td mat-cell *matCellDef="let element">
          {{ element.AffiliatePromoCode }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="utilitydisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: utilitydisplayedColumns"></tr>
    </table>
  </div>
  <mat-paginator
    #utilityPaginator="matPaginator"
    [pageSizeOptions]="[10, 20, 50]"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <!-- <div class="mt-5"> -->
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait while we retrieve your data
          </p>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
